import { useRouter } from 'next/router';
import { FC } from 'react';

import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useRedirect } from '@/hooks/useRedirect';
import { ThinEvent } from '@/resources/ThinEvent';

export const LibraryRedirect: FC<{ event?: ThinEvent }> = ({ event }) => {
  const router = useRouter();
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  // lecture/poster detail pages stay reachable after an event ends
  const allowedRoutes = [
    '/events/[eventId]/sessions/[sessionId]/lecture/[lectureId]',
    '/events/[eventId]/schedule/sessions/[sessionId]/lecture/[lectureId]',
    '/events/[eventId]/posters/[sessionId]/poster/[posterId]',
  ];

  const redirectCondition = event?.state === 'post_event' && !allowedRoutes.includes(router.route);

  useRedirect(redirectCondition, {
    href: '/events/[eventId]/library',
    asPath: `/events/${eventId}/library`,
    shallow: true,
  });

  return null;
};
